import styled from "styled-components";

const KoerberEmbed = styled.div`
  justify-content: center;
  > div {
    width: 100%;
  }
  .embed__video {
    width: 100%;
    padding-top: 56%;
    position: relative;
    height: 0;
  }

  .video__player {
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    position: absolute;
  }
`;
export { KoerberEmbed };
